<app-modal-container
  class="modal-with-video"
  [buttons]="{close: true}"
  [hidden]="!videoReady"
  [spinnerProps]="{ isSpinnerActive: true }"
  (closeButtonClicked)="closeButtonClickedEmitter.emit()">
    <iframe
      #videoPlayer
      width="822"
      height="462"
      [src]="vimeoUrl | safeUrl"
      allow="autoplay; fullscreen">
    </iframe>
</app-modal-container>

<div #spinnerDiv class="!static"></div>
